import { render, staticRenderFns } from "./amount-subsidy.vue?vue&type=template&id=423f1879"
import script from "./amount-subsidy.vue?vue&type=script&lang=ts"
export * from "./amount-subsidy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports